"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMerchantBySlugResponseSchema = exports.getMerchantBySlugParamsSchema = void 0;
const zod_1 = require("zod");
const api_schemas_1 = require("../base/api.schemas");
// ============================================
// INTERNAL SCHEMAS
// ============================================
// Public merchant info returned for registration lookup
// Only includes non-sensitive data needed for customer registration
const _PublicMerchantInfoSchema = zod_1.z.object({
    merchant_id: zod_1.z.number().int().positive(),
    merchant_name: zod_1.z.string().max(200),
    logo_url: zod_1.z.string().url().max(500).nullable(),
});
// ============================================
// PUBLIC MERCHANT API SCHEMAS
// ============================================
// GET /public/merchants/by-slug/:slug - Params
exports.getMerchantBySlugParamsSchema = zod_1.z.object({
    slug: zod_1.z.string().min(3).max(50).regex(/^[a-z0-9-]+$/),
});
// GET /public/merchants/by-slug/:slug - Response
// Returns basic merchant info for customer registration flow
exports.getMerchantBySlugResponseSchema = (0, api_schemas_1.dataResponseSchema)(_PublicMerchantInfoSchema);
